export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";

export const SET_ALL_PERMISSIONS = "SET_ALL_PERMISSIONS";
